import { CommandExecutor } from './command-executor';
import * as TSE from 'ts-events';

export declare interface SelectAccountCommandParameters {
    accountId: string;
    enable: boolean;
}

export class SelectAccountCommandExecutor extends CommandExecutor {
    public static commandExecutorCreated = new TSE.SyncEvent();

    constructor() {
        super();
        SelectAccountCommandExecutor.commandExecutorCreated.post(this);
    }

    public requestExecute = (options: SelectAccountCommandParameters) => {
        this.notifyExecute(options);
    }

}
